export const getCurrentEnvironment = (state) => () => {
  return localStorage.getItem('environment');
};

// export const getOboUserName = (state) => () => {
//   if ((state.userProfile || null) === null) {
//     return '';
//   }

//   if ((state.userProfile.oboUserName || null) === null) return '';
//   return state.userProfile.oboUserName;
// };
